var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "base-form",
        {
          attrs: {
            resource: _vm.$route.meta.resource,
            id: this.$route.params.id,
            readonly: _vm.readonly
          }
        },
        [
          _vm.$route.params.id
            ? _c(
                "div",
                { attrs: { slot: "bottom" }, slot: "bottom" },
                [_c("company-persons")],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }